import { Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { useTheme } from "@material-ui/core/styles";
import { useState } from "react";
import LabelsContext from "../../../lang/LabelsContext";
import ArticleCard from "../article-card/ArticleCard";
import ArticleDetailsService, { ArticleDetailsServiceType } from "./ArticleDetailsService";
import useStyles from "./ArticleDetailsStyle";
import EmailLog from "./email-log/log/EmailLog";
import Log from "./log/Log";
import Notes from "./notes/Notes";
import TabReview from "./tab-review/TabReview";
import TabReviewers from "./tab-reviewers/TabReviewers";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function ArticleDetails() {
  const classes = useStyles();
  const theme = useTheme();
  const { Labels } = LabelsContext();
  const [value, setValue] = useState(0);

  const { article }: ArticleDetailsServiceType = ArticleDetailsService();

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Typography variant="h5">{Labels.ARTICLE_DETAILS}</Typography>
      <ArticleCard data={article} index={0} />
      <AppBar position="static" color="default" className={classes.appBar}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label={Labels.REVIEWS} {...a11yProps(0)} />
          <Tab label={Labels.REVIEWERS} {...a11yProps(1)} />
          <Tab label={Labels.LOG} {...a11yProps(2)} />
          <Tab label={Labels.EMAIL_LOG} {...a11yProps(3)} />
          <Tab label={Labels.NOTES} {...a11yProps(4)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} dir={theme.direction}>
        <TabReview editorView={true} articleId={article?.id} />
      </TabPanel>
      <TabPanel value={value} index={1} dir={theme.direction}>
        <TabReviewers />
      </TabPanel>
      <TabPanel value={value} index={2} dir={theme.direction}>
        <Log />
      </TabPanel>
      <TabPanel value={value} index={3} dir={theme.direction}>
        <EmailLog />
      </TabPanel>
      <TabPanel value={value} index={4} dir={theme.direction}>
        <Notes />
      </TabPanel>
    </div>
  );
}
